<template>
  <div class="mb" style="z-index:1002">
    <div class="grada">
      <img src="../../assets/images/img2/joint_off.png" class="hide" @click="hide">
      <div class="textarea" v-html="text" contenteditable="true" @blur="getblur()" @input="inputText()">

      </div>
      <div class="flex_bet">
        <div class="flex_ali">
          <div class="grada_btn grada_btn2" @click="clearText">清空文本</div>
          <div class="grada_btn" @click="insertStart">{{start_state?'移除开始点':'插入开始点'}}</div>
          <div class="grada_btn" @click="insertEnd">{{end_state?'移除结束点':'插入结束点'}}</div>
        </div>
        <div class="play_btn" @click="listenTest">{{playTtsAudio.src?'停止播放':'试听效果'}}</div>
      </div>
    </div>
  </div>
</template>
<script>
// tts播放类
import PlayTtsAudio from "../../utils/PlayTtsAudio.js";
export default ({
  props: {
    ttsobj: {
        type: Object,
    },
  },
  data() {
    return {
      playTtsAudio: new PlayTtsAudio(), //tts实例化播放器对象
      frist_state:false,//输入框激活状态
      text:'',
      start_state:false,//开始点插入状态
      end_state:false,//结束点插入状态
      end_html:'<span class="grada_start" contenteditable="false">结束点</span>',
      start_html:'<span class="grada_start" contenteditable="false">开始点</span>'
    }
  },
  mounted(){
    this.text = this.ttsobj.text
  },
  methods: {
    // 关闭点击事件
    hide(){
      this.$emit('hide')
    },
    // 清空文本
    clearText(){
      const self = this
      this.$confirm('确定清空文本？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.text = ''
      })
    },
    // 获取逐句试听文本
    getText(){
      const textarea = $(".textarea").html()
      const start_state = (textarea.indexOf(this.start_html)>=0)
      const end_state = (textarea.indexOf(this.end_html)>=0)
      if(!start_state){
        this.$message('请插入开始点')
        return false
      }
      if(!end_state){
        this.$message('请插入结束点')
        return false
      }
      const reg = /<span class="grada_start" contenteditable="false">开始点<\/span>(.*?)<span class="grada_start" contenteditable="false">结束点<\/span>/g
      const con = textarea.match(reg)
      if(!con||con.length===0){
        this.$message('请正确插入开始点与结束点！')
        return false
      }
      return con[0].replace(this.end_html,'').replace(this.start_html,'')
    },
    // 试听效果
    listenTest(){
      if(this.playTtsAudio.src){
        this.playTtsAudio.stop()
        return
      }
      const self = this
      const con = this.getText()
      if(!con)return
      let json = this.ttsobj
      json.text = con
      let url = this.$store.state.app_api + this.$store.state.app_url.synctts;
      const loading = this.$loading({
        lock: true,
        text: "合成中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      this.$request.postHttp(json, url, (response) => {
        console.log(response)
        loading.close();
        if (response.rc === '3100') {
          self.$store.commit("setShowLogin", true);
          self.$store.commit("setLoginState", false);
          self.$message({
            message: '您的设备码已过期，请前往小程序重新生成！',
            type: 'warning'
          });
          return
        }
        self.playTtsAudio.play(response.model.audiourl,()=>{
          
        });
      })
    },
    // 插入结束点
    insertEnd(){
      if(!this.frist_state)return
      const html = this.end_html
      if(this.end_state){
          this.end_state = false
          let textarea = $(".textarea").html()
          $(".textarea").html(textarea.replace(html,''))
          return
      }
      this.insertHtmlAtCaret(html)
      this.end_state = true
    },
    // 插入开始点
    insertStart() {
      if(!this.frist_state)return
      const html = this.start_html
      if(this.start_state){
          this.start_state = false
          let textarea = $(".textarea").html()
          $(".textarea").html(textarea.replace(html,''))
          return
      }
      this.insertHtmlAtCaret(html)
      this.start_state = true
    },
    // 去除文本的html标签和空格
    removeHtmlCode(html) {
      return html
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/g, "")
        .replace(/\s*/g, "");
    },
    // 文本输入事件
    inputText() {
      let html = this.removeHtmlCode($(".textarea").html());
      this.text_length = html.length;
    },
    // 在指定位置插入内容
    insertHtmlAtCaret(html) {
      if (window.getSelection) {
        if (this.sel.getRangeAt && this.sel.rangeCount) {
          var el = document.createElement("div");
          el.innerHTML = html;
          var frag = document.createDocumentFragment(),
            node,
            lastNode;
          while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
          }
          this.range.insertNode(frag);
          // Preserve the selection
          if (lastNode) {
            this.range = this.range.cloneRange();
            this.range.setStartAfter(lastNode);
            this.range.collapse(true);
            this.sel.removeAllRanges();
            this.sel.addRange(this.range);
          }
        }
      } else if (document.selection && document.selection.type != "Control") {
        // IE < 9
        document.selection.createRange().pasteHTML(html);
      }
    },
    // 文本输入框失去光标事件
    getblur() {
      this.frist_state = true
      this.sel = window.getSelection();
      this.range = this.sel.getRangeAt(0);
    },
  }
})
</script>
<style scoped>
.hide{
  float: right;
  cursor: pointer;
}
.play_btn{
  padding: 4px 12px;
  background: #eee;
  margin-right: 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  color: #74b9ff;
  background: rgba(116, 185, 255, 0.1);
}
.grada .textarea {
  outline: none;
  background: #eee;
  box-sizing: border-box;
  padding: 20px;
  background-color: #eee;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 12px;
  min-height: 100px;
  max-height: 500px;
}
.grada_btn2 {
  color: #74b9ff !important;
  background: rgba(116, 185, 255, 0.1) !important;
}
.grada_btn {
  padding: 4px 12px;
  background: #eee;
  margin-right: 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
}
.grada {
  position: absolute;
  width: 1200px;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/make/gradatim.vue